// extracted by mini-css-extract-plugin
export default {"container":"VL-z"};